function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122 182C189.379 182 244 174.613 244 165.5V147.5C244 156.613 189.379 164 122 164C54.6213 164 0 156.613 0 147.5V165.5C0 174.613 54.6213 182 122 182Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M122 182C189.379 182 244 174.613 244 165.5V147.5H122H0V165.5C0 174.613 54.6213 182 122 182Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 147.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 147.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122 164C189.379 164 244 156.613 244 147.5C244 147.5 244 146.5 243.5 146.5C238.5 151 224.144 154.187 192 157C155 160.237 113.5 160.864 72.5 159C59.3234 158.401 6.5 154.5 0.500003 146C0 147 0 147.5 0 147.5C0 156.613 54.6213 164 122 164Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M128 160C195.379 160 250 152.613 250 143.5V125.5C250 134.613 195.379 142 128 142C60.6213 142 6 134.613 6 125.5V143.5C6 152.613 60.6213 160 128 160Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M128 160C195.379 160 250 152.613 250 143.5V125.5H128H6V143.5C6 152.613 60.6213 160 128 160Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 125.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 125.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128 142C195.379 142 250 134.613 250 125.5C250 125.5 250 124.5 249.5 124.5C244.5 129 230.144 132.187 198 135C161 138.237 119.5 138.864 78.5 137C65.3234 136.401 12.5 132.5 6.5 124C6 125 6 125.5 6 125.5C6 134.613 60.6213 142 128 142Z",
  fill: "url(#paint5_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M124 137C191.379 137 246 129.613 246 120.5V102.5C246 111.613 191.379 119 124 119C56.6213 119 2 111.613 2 102.5V120.5C2 129.613 56.6213 137 124 137Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M124 137C191.379 137 246 129.613 246 120.5V102.5H124H2V120.5C2 129.613 56.6213 137 124 137Z",
  fill: "url(#paint6_linear)",
  fillOpacity: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 102.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 102.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint7_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M124 119C191.379 119 246 111.613 246 102.5C246 102.5 246 101.5 245.5 101.5C240.5 106 226.144 109.187 194 112C157 115.237 115.5 115.864 74.5 114C61.3234 113.401 8.5 109.5 2.5 101C2 102 2 102.5 2 102.5C2 111.613 56.6213 119 124 119Z",
  fill: "url(#paint8_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M127 115C194.379 115 249 107.613 249 98.4999V80.5C249 89.6127 194.379 97 127 97C59.6213 97 5 89.6127 5 80.5V98.4999C5 107.613 59.6213 115 127 115Z",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M127 115C194.379 115 249 107.613 249 98.4999V80.5H127H5V98.4999C5 107.613 59.6213 115 127 115Z",
  fill: "url(#paint9_linear)",
  fillOpacity: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 80.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 80.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint10_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M127 97C194.379 97 249 89.6127 249 80.5C249 80.5 249 79.5 248.5 79.5C243.5 84 229.144 87.1874 197 90C160 93.2375 118.5 93.8636 77.5 92C64.3234 91.401 11.5 87.5 5.5 79C5 80 5 80.5 5 80.5C5 89.6127 59.6213 97 127 97Z",
  fill: "url(#paint11_linear)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M131 89.9999C198.379 89.9999 253 82.6126 253 73.4999V55.5C253 64.6127 198.379 72 131 72C63.6213 72 9 64.6127 9 55.5V73.4999C9 82.6126 63.6213 89.9999 131 89.9999Z",
  fill: "currentColor"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M131 89.9999C198.379 89.9999 253 82.6126 253 73.4999V55.5H131H9V73.4999C9 82.6126 63.6213 89.9999 131 89.9999Z",
  fill: "url(#paint12_linear)",
  fillOpacity: 0.25
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 55.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 55.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint13_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M131 72C198.379 72 253 64.6127 253 55.5C253 55.5 253 54.5 252.5 54.5C247.5 59 233.144 62.1874 201 65C164 68.2375 122.5 68.8636 81.5 67C68.3234 66.401 15.5 62.5 9.5 54C9 55 9 55.5 9 55.5C9 64.6127 63.6213 72 131 72Z",
  fill: "url(#paint14_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M122 67.9999C189.379 67.9999 244 60.6126 244 51.4999V33.5C244 42.6127 189.379 50 122 50C54.6213 50 0 42.6127 0 33.5V51.4999C0 60.6126 54.6213 67.9999 122 67.9999Z",
  fill: "currentColor"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M122 67.9999C189.379 67.9999 244 60.6126 244 51.4999V33.5H122H0V51.4999C0 60.6126 54.6213 67.9999 122 67.9999Z",
  fill: "url(#paint15_linear)",
  fillOpacity: 0.25
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 33.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 33.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint16_linear_for_6chip)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M122 50C189.379 50 244 42.6127 244 33.5C244 33.5 244 32.5 243.5 32.5C238.5 37 224.144 40.1874 192 43C155 46.2375 113.5 46.8636 72.5 45C59.3234 44.401 6.5 40.5 0.500003 32C0 33 0 33.5 0 33.5C0 42.6127 54.6213 50 122 50Z",
  fill: "url(#paint17_linear)"
});

var _ref32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 244,
  y1: 182,
  x2: 118,
  y2: 182,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 136,
  x2: 122,
  y2: 158,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -3.63368e-8,
  y1: 164,
  x2: 244,
  y2: 164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250,
  y1: 160,
  x2: 124,
  y2: 160,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 143,
  y1: 114,
  x2: 128,
  y2: 136,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 6,
  y1: 142,
  x2: 250,
  y2: 142,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 246,
  y1: 137,
  x2: 120,
  y2: 137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 139,
  y1: 91,
  x2: 124,
  y2: 113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2,
  y1: 119,
  x2: 246,
  y2: 119,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 249,
  y1: 115,
  x2: 123,
  y2: 115,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 142,
  y1: 69,
  x2: 127,
  y2: 91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 5,
  y1: 96.9999,
  x2: 249,
  y2: 96.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 253,
  y1: 90,
  x2: 127,
  y2: 90,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 146,
  y1: 44,
  x2: 131,
  y2: 66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 9,
  y1: 71.9999,
  x2: 253,
  y2: 71.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 244,
  y1: 68,
  x2: 118,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_for_6chip",
  x1: 137,
  y1: 22,
  x2: 122,
  y2: 44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: -3.63368e-8,
  y1: 49.9999,
  x2: 244,
  y2: 49.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})));

function Svg6Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 184,
    viewBox: "0 0 259 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Chip);
export default __webpack_public_path__ + "static/media/6chip.48b5e83d.svg";
export { ForwardRef as ReactComponent };